export const SLIP_ADD_EVENT = "SLIP_ADD_EVENT";
export const SLIP_REMOVE_EVENT = "SLIP_REMOVE_EVENT";
export const SLIP_UPDATE_STAKE = "SLIP_UPDATE_STAKE";
export const SLIP_UPDATE_COEF = "SLIP_UPDATE_COEF";
export const SLIP_DIALOG_CLEAN_YOUR_PICKS = "SLIP_DIALOG_CLEAN_YOUR_PICKS";
export const SLIP_CLEAN = "SLIP_CLEAN";
